import { Slider } from "antd";
import "./CustomSlider.less"

type CustomSliderProps = {
    value: number;
    onValueChange: (a: number) => void;
    onChangeComplete?: (a: number) => void;
    min: number;
    max: number;
    step: number;
    style?: React.CSSProperties;
    handleClass?: string;
    railClass?: string;
    trackClass?: string;
    tooltipFormatter?: (a: number) => React.ReactNode;
    className?: string;
};

export const CustomSlider = (props:CustomSliderProps): React.ReactElement => {
    return <Slider className={`custom-slider ${props.className || ""}`}
                   classNames={{handle: props.handleClass || "custom-slider-handle",
                                rail: props.railClass || "custom-slider-rail",
                                track: props.trackClass || "custom-slider-track"}}
                   min={props.min} max={props.max} step={props.step} value={props.value} onChange={props.onValueChange} tipFormatter={null}
                   style = {props.style || {}}
                   onChangeComplete={props.onChangeComplete || (() => {})}></Slider>;
};